<div class="form-container">
    <app-dynamic-form [formGroup]="bankAccountForm" [formConfig]="bankAccountFormConfig" (onValueChange)="handleValueChange($event)"></app-dynamic-form>

    <app-file-upload
            [title]="'Click to upload cancelled cheque or drag and drop'"
            [(files)]="attachments"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="false"
            [disabled]="viewMode"
            (filesChange)="onFileChange($event)"
    ></app-file-upload>
</div>